import {HandlerRegObject, makeHandlerRegObject, Fn} from "./signal.js";

export type HookCallback<P extends unknown[], R> = Fn<[Fn<P,R>, ...P],R>;
export type HookedFunction<P extends unknown[], R> = {
    (...args: P): R;
    bypass(...args: P): R;
    original(...args: P): R;
} & HandlerRegObject<HookCallback<P, R>>;
export function hookable<P extends unknown[], R, C extends object>(fn_: Fn<P, R>, ctx: ClassMethodDecoratorContext<C> | C): HookedFunction<P,R> {
    var fun = makeHandlerRegObject<HookCallback<P, R>>(function (...args: P): R {
        const hooks = Object.values(fun.handlers);
        var makeCb = (idx: number) => ((idx >= hooks.length) ? fn_.bind(this) : (...args: P): R => hooks[idx].call(this, makeCb(idx + 1), ...args));
        return makeCb(0)(...args);
    }) as HookedFunction<P, R>;
    if ('addInitializer' in ctx) {
        ctx.addInitializer(function() {
            fun.bypass = fn_.bind(this);
        });
    } else if (ctx.hasOwnProperty('constructor')) {
        fun.original = fn_;
    } else {
        fun.bypass = fn_.bind(ctx);
        fun.original = fn_;
    }
    return fun;
}
export function installHook<P extends unknown[], R>(hooked: Fn<P, R>, hookCb: HookCallback<P, R>) {
    return (hooked as HookedFunction<P, R>).connect(hookCb);
}
export function hooked<P extends unknown[], R>(fn: Fn<P, R>): HookedFunction<P, R> {
    return fn as HookedFunction<P, R>;
}
